import type { CalendarProvider } from '@plura/shared/types';

/** Small square marks — sidebar avatars, wizard rows, settings panel chips. */
export const SCHEDULER_PROVIDER_LOGOS: Record<CalendarProvider, string> = {
  CALENDLY: '/images/calendly-logo-small.png',
  CALCOM: '/images/cal-com.png',
  GOOGLE_CALENDAR: '/images/google-cal.png',
};

/** Small square marks on dark surfaces (e.g. dark-mode sidebar avatars). */
export const SCHEDULER_PROVIDER_LOGOS_ON_DARK: Record<CalendarProvider, string> = {
  CALENDLY: '/images/calendly-logo_white.png',
  CALCOM: '/images/cal-com-light.png',
  GOOGLE_CALENDAR: '/images/google-cal.png',
};

/** Full wordmarks — integration connect tiles and other larger surfaces. */
export const SCHEDULER_PROVIDER_FULL_LOGOS: Record<
  CalendarProvider,
  { onLight: string; onDark: string }
> = {
  CALENDLY: {
    onLight: '/images/calendly-logo.png',
    onDark: '/images/calendly-logo_white.png',
  },
  CALCOM: {
    onLight: '/images/cal-logo-dark.svg',
    onDark: '/images/cal-logo-white.svg',
  },
  GOOGLE_CALENDAR: {
    onLight: '/images/google-cal.png',
    onDark: '/images/google-cal.png',
  },
};

export function getSchedulerProviderLogo(
  provider: CalendarProvider | null | undefined,
  options?: { onDark?: boolean; full?: boolean },
): string | null {
  if (!provider) return null;

  if (options?.full) {
    const logos = SCHEDULER_PROVIDER_FULL_LOGOS[provider];
    return options.onDark ? logos.onDark : logos.onLight;
  }

  return options?.onDark
    ? SCHEDULER_PROVIDER_LOGOS_ON_DARK[provider]
    : SCHEDULER_PROVIDER_LOGOS[provider];
}
